export const PERIOD_YEARS = 'years';
export const PERIOD_QUARTERS = 'quarters';
export const PERIOD_MONTHS = 'months';
export const PERIOD_DAYS = 'days';

export const PERIODS_MAP = [PERIOD_YEARS, PERIOD_QUARTERS, PERIOD_MONTHS, PERIOD_DAYS];

// Row types of the project plan tree, mirroring the `type` key the gantt payload carries.
// Owner edits dispatch on these — a divergent literal would send the write to the wrong
// endpoint, and so to the wrong record — which is why the project plan gantt reads them
// from here. Note that components/position_activities/components/GanttChart.js still
// declares its own identical copies against the same payload; consolidating that one onto
// these constants is worth doing separately.
export const CATEGORY_TYPE = 'category';
export const SUBCATEGORY_TYPE = 'subcategory';
export const ACTIVITY_TYPE = 'activity';

// Mirrors App\Enums\ProjectActivityStatus::Complete (value 2).
// Status may arrive as an integer or a string from the API, so keep the loose
// equality check (== / string-tolerant) at call sites.
export const PROJECT_ACTIVITY_STATUS_COMPLETE = 2;
